













































































import {
  computed,
  defineComponent,
  PropType,
  ref,
  toRefs
} from '~/utils/nuxt3-migration'
import AuthorizedPartnerBadge from '~/components/shared/audits/badges/AuthorizedPartnerBadge.vue'
import SpotCheckBadge from '~/components/shared/audits/badges/SpotCheckBadge.vue'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { useI18n } from '~/compositions/i18n'
import { ciLocationPin } from '~/icons/source/regular/location-pin'
import { ciAngleLeft } from '~/icons/source/regular/angle-left'
import { AuditShop } from '~/models/audit/shop'
import { useAudits } from '~/compositions/audits'

export default defineComponent({
  components: {
    CImg,
    AuthorizedPartnerBadge,
    SpotCheckBadge
  },
  props: {
    selectedShopOption: {
      type: Object as PropType<AuditShop>,
      required: true
    },
    backTitle: {
      type: String,
      required: true
    }
  },
  setup(props, { emit }) {
    const { selectedShopOption } = toRefs(props)
    const { t } = useI18n()
    const { placeholderIcon } = useAudits()

    const isPackageExpanded = ref(false)

    const distance = computed(() => {
      if (!selectedShopOption.value.distanceFromGeolocation) {
        return null
      }
      const distance: number = parseFloat(
        selectedShopOption.value.distanceFromGeolocation.toFixed(0)
      )
      return `${distance} ${t('km_away')}`
    })

    const packageClicked = () => {
      emit('clicked')
    }

    return {
      packageClicked,
      distance,
      ciLocationPin,
      isPackageExpanded,
      ciAngleLeft,
      placeholderIcon
    }
  }
})
